var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mouse-event-container',[_c('div',{attrs:{"data-component":"contentStack"}},_vm._l((_vm.data.stack),function(piece,i){return _c('div',{key:i,staticClass:"stack-item"},[_c(("component_" + (piece.type)),{key:piece.type,tag:"component",attrs:{"data":piece}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f617d698","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentStack.vue
// module id = 9t57
// module chunks = 1